import React from 'react';

export default function AccuracyRateTag(props) {
  const { value = 0 } = props;

  const accuracyRateClass = value >= 0 && value <= 33.33 ? 'square-tag--danger' : value > 33.33 && value <= 66.66 ? 'square-tag--warning' : 'square-tag--success';

  return (
    <span
      className={`square-tag ${accuracyRateClass}`}
      style={{ fontSize: 14 }}
    >
      {value ?? '-'}%
    </span>
  );
}
